// extracted by mini-css-extract-plugin
export var label = "_lf-2";
export var slideContainer = "_lf-0";
export var slider = "_lf-1";